import styles from './LkmAppealDetailInfoButtons.module.scss'

import { FC, useEffect, useState } from 'react'
import { Button } from 'ui'
import {
  useClaimAcceptMutation,
  useClaimRefuseMutation,
  useSubmitOrderFormMutation,
} from 'feature/lkmAppeals/redux/LkmAppeals.api'
import { CircularProgress } from '@mui/material'
import { LkmAppealOfferModal } from '../LkmAppealOfferModal'
import { LkmAppealDetailResponse } from 'feature/lkmAppeals/types'
import { useAppealButtonsUtils } from 'feature/lkmAppeals/hooks/useAppealButtonsUtils'
import { useNavigate } from 'react-router'

type LkmAppealDetailProps = {
  isAcceptButtonVisible: boolean
  isRespondButtonVisible: boolean
  data: LkmAppealDetailResponse['result']
}

export const LkmAppealDetailInfoButtons: FC<LkmAppealDetailProps> = ({
  isAcceptButtonVisible,
  isRespondButtonVisible,
  data,
}) => {
  const navigate = useNavigate()

  const [actionCompleted, setActionCompleted] = useState(false)
  const {
    open,
    selectedOrder,
    handleCloseOfferModal,
    handleRespondButtonClick,
  } = useAppealButtonsUtils()

  const [
    submitOrderForm,
    { isLoading: isSubmitOrderFormLoading, isSuccess: respondedSuccess },
  ] = useSubmitOrderFormMutation()
  const [
    claimAccept,
    { isLoading: claimAcceptLoading, isSuccess: claimAcceptSuccess },
  ] = useClaimAcceptMutation()
  const [
    claimRefuse,
    { isLoading: claimRefuseLoading, isSuccess: claimRefuseSuccess },
  ] = useClaimRefuseMutation()

  useEffect(() => {
    if (claimAcceptSuccess || claimRefuseSuccess) {
      setActionCompleted(true)
    }
  }, [claimAcceptSuccess, claimRefuseSuccess])

  const respondedButtonVisible =
    !respondedSuccess && !isAcceptButtonVisible && isRespondButtonVisible

  const handleRefuse = async (id: number) => {
    await claimRefuse({
      claimId: id,
    })

    navigate('/orders?status=in_progress')
  }

  if (isAcceptButtonVisible && !actionCompleted) {
    return (
      <div className={styles.appealInfoButtons}>
        <Button
          variant='contained'
          color='primary'
          size='small'
          className=''
          onClick={() =>
            claimAccept({
              claimId: data.id,
            })
          }
          disabled={claimAcceptLoading || claimRefuseLoading}
          data-testid='lkm-detail-confirm-btn'
        >
          {claimAcceptLoading ? <CircularProgress size={25} /> : 'Подтвердить'}
        </Button>
        <Button
          variant='contained'
          color='primary'
          size='small'
          onClick={() => handleRefuse(data.id)}
          disabled={claimAcceptLoading || claimRefuseLoading}
          data-testid='lkm-detail-cancel-btn'
        >
          {claimRefuseLoading ? <CircularProgress size={25} /> : 'Отменить'}
        </Button>
      </div>
    )
  }

  if (respondedButtonVisible) {
    return (
      <>
        <div className={styles.appealInfoButtons}>
          <Button
            size='small'
            variant='contained'
            className={styles.appeal__button}
            onClick={e => handleRespondButtonClick(e, data)}
            data-testid='lkm-detail-respond-btn'
          >
            Откликнуться
          </Button>
        </div>
        <LkmAppealOfferModal
          open={open}
          onClose={handleCloseOfferModal}
          description={{
            id: selectedOrder?.number ?? 0,
            name: selectedOrder?.name,
          }}
          submitOrderForm={submitOrderForm}
          isLoading={isSubmitOrderFormLoading}
        />
      </>
    )
  }

  return <></>
}
